import moment from 'moment';
// import html2canvas from 'html2canvas';
import Util from '../common/utils';
// import strings from '../../eyeguide-localization/strings.common';

const logo = require('../../images/logo_black.png');
const AVG_BASELINE = 36010;

export default function TestPdf(props: any) {
    let state = props.state;
    // console.log('TestPdf props', state);
    let currDate = new Date().toISOString();
    moment.locale(navigator.language);
    currDate = moment(currDate).format('MMM DD[,] YYYY h[:]mm A');
    let testDate = new Date(state.testResult.testtimestamp).toISOString();
    moment.locale(navigator.language);
    testDate = moment(testDate).format('DD/MM/YYYY');
    let testScore = parseFloat(state.testResult.score);
    let baselineScore = -1;
    if (state.testResult.baseline === 0) {
        for (let i = state.testHistory.length - 1; i >= 0; i--) {
            if (state.testHistory[i].baseline === 1) {
                let baseline = state.testHistory[i];
                baselineScore = parseFloat(baseline.score);
            }
        }
        if (state.testHistory.length === 0 && state.baselineTestData !== undefined) {
            baselineScore = parseFloat(state.baselineTestData.score);
        }
    }
    let birthDate = '';
    state.testResult.athlete.playerinfo.forEach(element => {
        if (element.playerinfoname === 'birthdate') {
            console.log('birthdate', element.playerinfovalue);
            birthDate = new Date(parseInt(element.playerinfovalue, 10)).toISOString();
            birthDate = moment(birthDate).format('MM/DD/YYYY');
        }
    });
    let doc = props.doc;
    let {athlete, testinfo, testtag} = state.testResult;
    // if (props.index === 0) {
    //     addCoverPage(doc, props.singleTest, athlete);
    //     doc.addPage();
    // }
    let filename = Util.getRandomAlphaNum();
    
    return props.setCanvas(filename)
    .then(image => {
        doc.addImage(logo , 'PNG', 20, 20, 150, 30);
        let headerName = athlete.firstname + ' ' + athlete.lastname
            + (birthDate.length ? ('  DOB: ' + birthDate) : '') + '  Test Date: ' + testDate
            + (testinfo.length ? ' (eye: LEFT)' : ' (eye: RIGHT)');
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(11);
        doc.text(headerName, birthDate.length ? 260 : 310, 40);
        doc.setFontSize(10);
        doc.text(currDate, 660, 40);
        doc.setFontSize(11);

        let tag = testtag ? `Test Type: ${testtag}` : '',
            xOffset = (doc.internal.pageSize.width / 2) 
                    - (doc.getStringUnitWidth(tag) * doc.internal.getFontSize() / 2); 
        doc.text(tag, xOffset, 52);
    
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(15);
        doc.text('Your Focus Score', 100, 80);

        doc.addImage(image, 'PNG', 30, 100, 1024 / 4, 768 / 4); 

        doc.setFontSize(13);
        doc.text(
'Your Score: ' + state.testResult.range.toUpperCase() + ' '
+ testScore.toLocaleString(undefined, {maximumFractionDigits: 2}),
310,
105
);
        doc.text('Your Visual', 310, 180);
        doc.setFontSize(14);
        doc.text('What Your Focus Score Can Tell You', 470, 380);
    
        doc.setFont('Helvetica', 'normal');
        doc.setFontSize(9);
        doc.text(
`We are measuring functional eye movement using the “smooth pursuit” test. Lower scoring indicates greater eye
tracking accuracy. Higher scoring, especially when compared to your baseline score (the best test you previously
recorded), indicates an inability to follow smoothly (by location and time) the stimulus as it moves across the
screen.`,
310,
120
);
        doc.text(
`If this is a baseline score, the white figure 8 line is the exact path the stimulus followed.
The blue line represents the path your eyes followed in attempting to smoothly pursue the stimulus. Visually, you
can see how well you did and how your score is created.

If you were taking a test comparing yourself to a baseline you previously recorded, you would see your prior blue
baseline test pathway, and then as an overlay either:

   a green line showing your follow up test pathway that was in the same scoring range as your baseline (blue)
   test, or
   a red line showing your follow up test pathway that was in a higher scoring range than your baseline (blue) test`,
310,
195
);
        doc.text(
`Focus captures 1,200 snapshots (also called fixations) of what you are seeing, exactly
where you are seeing it, in just 10 seconds. This smooth pursuit test and other kinds
of eye tracking (or functional eye movement) tests have been used as a guide to how
well your brain may be functioning (think of the doctor’s “follow my finger” test).`,
420,
400,
{align: 'justify', maxWidth: '335'}
);
        doc.text(
`The eyes don’t lie. Measuring how well you can follow a target on a designated
pathway is a fast, reliable way to understand aspects of your cognitive wellness.
Focus’s smooth pursuit test is so easy that you should be able to get roughly the
same score over and over. However, if anything is occurring, such as fatigue through
overwork or poor sleep, bad nutrition, or other factors that may effect your ocular
motor (eye movement) function, it may be harder to achieve the same results
compared to when you are at peak performance. Regular Focus testing helps you to
quickly and reliably monitor your wellness.`,
420,
465,
{align: 'justify', maxWidth: '335'}
);
        doc.setFillColor(0, 0, 0);
        doc.circle(310, 265, 2, 'F');
        doc.circle(310, 285, 2, 'F');
        doc.rect(20, 330, 750, 4, 'F');
        doc.text(
`Curious as to how you
compare to others? Here
are some helpful charts
that show how your Focus
score matches up to
others. Your score is
the blue tab; the average
score of others is the
green tab.`,
22,
380,
{align: 'justify', maxWidth: '100'}
);
        doc.text('Other', 20, 500);
        doc.setFillColor(0, 128, 0);
        doc.rect(20, 505, 45, 7, 'F');
        doc.text('Your Score', 20, 525);
        doc.setFillColor(0, 0, 225);
        doc.rect(20, 530, 45, 7, 'F');
        doc.setFont('Helvetica', 'bold');
        doc.text('Lower scoring indicates greater eye tracking accuracy.', 145, 545);
        let tableX = baselineScore > -1 ? 145 : 205;
        drawTable(doc, tableX, testScore, AVG_BASELINE);
        doc.setFont('Helvetica', 'bold');
        doc.setFontSize(10);
        doc.text('Your Score vs', tableX + 27, 381);
        doc.text('Community Average', tableX + 12, 394);
        if (baselineScore > -1) {
            tableX = 285;
            doc.text('Your Score vs', tableX + 28, 381);
            doc.text('Your Baseline', tableX + 28, 394);
            drawTable(doc, tableX, testScore, baselineScore);
        }
        addDisclaimer(doc);
        if (props.isLast) {
            if (!props.requireDataURI) {
            doc.save(filename + '.pdf');
            }
            console.log(doc);
            props.notifyDownload(props.requireDataURI ? doc.output ('datauristring') : '');
        } else {
            doc.addPage();
        }
    });
}

function drawTable(doc: any, tableX: number, testScore: number, baseline: number) {
    let tableY = 370;
    doc.line(tableX, tableY, tableX + 120, tableY);
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9);
    doc.line(tableX, 400, tableX + 120, 400);
    let y1 = 412;
    for (let i = 0; i < 11; i++) {
        let yi = y1 + i * 12;
        doc.line(tableX, yi, tableX + 120, yi);
        doc.text('' + (i * 10000), tableX + 35, yi - 2, {align: 'right'});
        if (i === 10) {
            doc.line(tableX, tableY, tableX, yi);
            doc.line(tableX + 120, tableY, tableX + 120, yi);
            doc.line(tableX + 42, 400, tableX + 42, yi);
        }
    }
    let unit = 12 / 10000;
    let scoreY = y1 + (unit * baseline);
    doc.setFillColor(0, 128, 0);
    doc.rect(tableX + 60, scoreY, 45, 7, 'F');
    scoreY = y1 + (unit * testScore);
    doc.setFillColor(0, 0, 225);
    doc.rect(tableX + 60, scoreY, 44, 7, 'F');
}

function addDisclaimer(doc: any) {
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(8);
    doc.setFontType('italic');
    doc.text(
'Disclaimer: Information and statements provided on www.Eye.Guide or about EyeGuide Focus, ' +
'in written or verbal communications, or in any information\nprovided by EyeGuide, Inc. ' + 
'have not been evaluated by the FDA and are not intended to diagnose, treat, cure or ' +
'cure or prevent any health condition or disease.',
90,
580,
{align: 'justify', maxWidth: '570'}
);
}

// function addCoverPage(doc: any, singleTest: boolean, profileInfo: any) {
//     strings.setLanguage(navigator.language);
//     console.log(navigator.language);
//     // Page 1
//     // Logo
//     doc.addImage(logo, 'PNG', 48, 64, 276 , 55);
//     // Labels
//     doc.setFont('Helvetica', 'normal');
//     doc.setFontSize(12);
//     if (singleTest) {
//         doc.text(strings.lsName + ':', 48, 320);
//     }
//     doc.text(strings.lsProvidedByTxt + ':', 48, 405);
//     doc.text(strings.lsDateTimeDownloadTxt + ':', 48, 490);
//     // Data
//     doc.setFont('Helvetica', 'bold');
//     doc.setFontSize(16);
//     if (singleTest) {
//         doc.text((profileInfo.firstname + ' ' + profileInfo.lastname) , 48, 343);
//     } // Player
//     doc.text(profileInfo.organizationname, 48, 428); // Organization Name

//     let currdate = new Date().toISOString();
//     console.log('moment date', moment(currdate).format('DD MMMM YYYY [@] h[:]mm[:]ss A')); 
//     moment.locale(navigator.language);
//     doc.text(moment(currdate).format('DD MMMM YYYY [@] h[:]mm[:]ss A'), 48, 513); // Downloaded date time
//     addDisclaimer(doc);
// }



// WEBPACK FOOTER //
// ./src/components/test/testPdf.tsx